
/**
 * CONTINAS CONTANTS URL ENDPOINTS
 */

const ENDPOINTS = {
  ERROR: '/error',
  LOGIN: '/v1/main/auth/login',
  LOGOUT: '/v1/main/auth/logout',
  AUTH_FAKE: '/v1/main/auth/fake',
  REGISTER: '/v1/main/auth/register',
  COUNTRIES: '/v1/main/countries',
  SPORTS: '/v1/main/sports',
  USER: '/v1/main/auth/user',
  USER_PROFILE: '/v1/main/auth/profile',
  USER_PASSWORD: '/v1/main/auth/password',
  PLAYERS: '/v1/main/players',
  HOMEPAGE_EVENTS: '/v1/collections/homepage/events', // @deprecated Use sport-specific endpoints instead
  HOMEPAGE_UPCOMING: '/v1/collections/homepage/upcoming',
  HOMEPAGE_FOOTBALL: '/v1/collections/homepage/football',
  HOMEPAGE_BASEBALL: '/v1/collections/homepage/baseball',
  HOMEPAGE_BASKETBALL: '/v1/collections/homepage/basketball',
  HOMEPAGE_NBA: '/v1/collections/homepage/nba',
  AVAILABLE_LEAGUES: '/v1/collections/available-leagues',
  PREMATCH_EVENTS: '/v1/collections/prematch/events',
  AZ_MENU: '/v1/collections/atozed/menu',
  BETS_PLACE: '/v1/main/bets/place',
  PREPAID_BETS_PLACE: '/v1/main/bets/prepaid-place',
  QUICKBET_SEARCH: '/v1/quickbet/search',
  /**
   * player tickets
   */
  BETS_MYBETS_LIST: '/v1/main/bets/mybets',
  BETS_LIST: '/v1/main/bets/list',
  BETS_READ: '/v1/main/bets/ticket',
  /**
   * virtual sports web
   */
  VIRTUAL_SPORTS_WEB: {
    SESSION_OPEN: '/v1/virtuals/web/session/open',
  },
  /**
   * casino web
   */
  CASINO_WEB: {
    SESSION_OPEN: '/v1/casino/session/open',
  },
  /**
   * poker web
   */
  POKER_WEB: {
    SESSION_OPEN: '/v1/poker/session/open',
  },
  /**
   * virtual sports CLIENT
   */
  VIRTUAL_SPORTS_CLIENT: {
    PINCODE_VERIFY: '/v1/virtual-sports/client/pincode/verify',
    DEVICE_INFO: '/v1/virtual-sports/client/device/info',
  },
  /**
   * PLATFORM
   */
  PLATFORM: {
    SESSIONS_START: '/v1/sessions/start',
    SESSIONS_CSRF: '/v1/sessions/csrf',
    SESSIONS_TOKEN: '/v1/sessions/token',
    SESSIONS_CLOSE: '/v1/sessions/close',
    SESSIONS_PREPAID_SHOW: '/v1/sessions/prepaid',
    SESSIONS_PREPAID_CREATE: '/v1/sessions/prepaid',
    SESSIONS_PREPAID_DELETE: '/v1/sessions/prepaid/delete',
    WALLETS_PAY: '/v1/wallets/pay',
    WALLETS_TOPUPS: '/v1/wallets/topups',
  }
};

export default ENDPOINTS;